import { axios } from "../../helpers/axios";
import { isAuth } from "../../helpers/cookies";
import { JOB_URL, GET_JOB_MESSAGES_URL, GET_JOB_LIST, SEND_PROOF, PROOF_LOG_TABLE, VIEW_PROOF, PROOF_APPROVE, PROOF_REJECT, ADD_BRAND, GET_BRAND_LIST, REMOVE_BRAND, REMOVE_BRAND_ITEM, SIDEBAR_MENU_URL, FOLDER_URL, DOWNLOAD_CORRECTIONS_REPORT_URL, DOWNLOAD_COMPLETED_REPORT_URL } from "./jobConstants";
import qs from "qs";

export const api_get_company_job_form_url = async (company_id, process_id) => {
  return axios.get(JOB_URL + '/' + company_id + '/forms/' + process_id);
};

export const api_create_send_message__url = async (job_id, action_type, data) => {
  return axios.post(JOB_URL + '/' + job_id + '/send-message',
    data,
    {
      params: { action_type },
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
};

export const api_get_job_messages_url = async (job_id) => {
  return axios.get(GET_JOB_MESSAGES_URL + job_id);
};

export const api_submit_job_url = async (company_id, process_id, formData, stage_id) => {
  let url = JOB_URL + '/' + company_id + '/' + 'process' + '/' + process_id + '/submit';

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  if (stage_id) {
    config.params = { stage_id };
  }

  return axios.post(url, formData, config);
}

export const api_get_job_detail_url = async (job_id) => {
  return axios.get(JOB_URL + '/details/' + job_id);
};

export const api_update_job_url = async (job_id, job_data) => {
  return axios.put(JOB_URL + '/update/' + job_id, job_data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const api_download_file_url = async (job_id, file_key, d_type) => {
  return axios.get(JOB_URL + '/download', {
    params: { job_id, file_key, d_type }
  });
};

export const api_download_zip_file_url = async (job_id, comp_file_list) => {
  return axios.get(JOB_URL + '/zip_download', {
    params: { job_id, comp_file_list },
    responseType: "blob"
  });
};
export const api_job_list_url = async (company_id, process_id, stage_id, skip = 0, limit = 10, qn, column, from_date, to_date, correction_type) => {
  return axios.get(company_id + '/' + GET_JOB_LIST + '/' + process_id + '/' + stage_id, {
    params: { skip, limit, qn, column, from_date, to_date, correction_type },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  })
}

export const api_send_proof = async (data) => {
  return axios.post(SEND_PROOF, data)
}

export const api_get_proof_log = async (payload) => {
  return axios.get(PROOF_LOG_TABLE, {
    params: payload?.job_id ? { job_id: payload.job_id } : {}
  })
}

export const api_viewproof = async (proof_id) => {
  return axios.get(VIEW_PROOF, {
    params: { proof_id }
  });
};

export const api_proof_approve = async ({ proof_id }) => {
  return axios.put(PROOF_APPROVE, null, {
    params: { proof_id },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const api_proof_reject = async ({ proof_id, comment }) => {
  return axios.put(PROOF_REJECT, null, {
    params: { proof_id, comment },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const api_add_brand = async ({ job_id, prooflog_id, name, search_param, file_path, is_personal, folder_id, new_folder_name }) => {
  // Strip full Linode URL to relative path if needed
  let cleanFilePath = file_path;
  if (cleanFilePath && typeof cleanFilePath === 'string') {
    cleanFilePath = cleanFilePath.replace(/^https?:\/\/[^/]+\.linodeobjects\.com\//, '');
    cleanFilePath = decodeURIComponent(cleanFilePath);
  }

  // Ensure job_id is always set - fallback to URL
  let finalJobId = job_id;
  if (!finalJobId && finalJobId !== 0) {
    const match = window.location.pathname.match(/\/(?:job-detail|update-job)\/(\d+)/);
    if (match) finalJobId = parseInt(match[1]);
  }

  console.log('[api_add_brand] Sending:', { job_id: finalJobId, prooflog_id, file_path: cleanFilePath, is_personal, folder_id, new_folder_name });
  return axios.post(ADD_BRAND, { job_id: finalJobId, prooflog_id, name, search_param, file_path: cleanFilePath, is_personal, folder_id, new_folder_name });
};

export const api_create_folder = async ({ name, parent_id, is_personal }) => {
  return axios.post(FOLDER_URL, { name, parent_id, is_personal });
};

export const api_get_folders = async ({ parent_id, is_personal, all_levels, search }) => {
  return axios.get(FOLDER_URL, {
    params: { parent_id, is_personal, all_levels, search }
  });
};

export const api_update_folder = async ({ folder_id, name }) => {
  return axios.put(`${FOLDER_URL}/${folder_id}`, { name });
};

export const api_delete_folder = async (folder_id) => {
  return axios.delete(`${FOLDER_URL}/${folder_id}`);
};




export const api_get_brand_list = async ({ job_id, process_id, search, company_id, is_personal, folder_id }) => {
  return axios.get(GET_BRAND_LIST, {
    params: {
      job_id,
      process_id,
      search,
      company_id,
      is_personal,
      folder_id
    }
  });
};

export const api_remove_brand = async (item_id) => {
  return axios.delete(`${REMOVE_BRAND_ITEM}/${item_id}`);
};

export const api_get_sidebar_menu = async (process_id, qn, column, from_date, to_date, correction_type) => {
  return axios.get(SIDEBAR_MENU_URL, {
    params: { process_id, qn, column, from_date, to_date, correction_type },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const api_download_corrections_report = async (from_date, to_date) => {
  return axios.get(DOWNLOAD_CORRECTIONS_REPORT_URL, {
    params: { from_date, to_date },
    responseType: "blob",
  });
};

export const api_add_correction_url = async (job_id, item_id, formData) => {
  return axios.post(`${JOB_URL}/${job_id}/items/${item_id}/corrections`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const api_update_correction_url = async (job_id, item_id, correction_id, formData) => {
  return axios.put(`${JOB_URL}/${job_id}/items/${item_id}/corrections/${correction_id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const api_download_completed_report = async (from_date, to_date) => {
  return axios.get(DOWNLOAD_COMPLETED_REPORT_URL, {
    params: { from_date, to_date },
    responseType: "blob",
  });
};